// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  apiUrl = environment.url;


  constructor(private http: HttpClient) {}

  isAuthenticated(): Observable<boolean> {
    const token = sessionStorage.getItem('token');
    return new Observable<boolean>((observer) => {
      if (token) {
        observer.next(true);
      } else {
        observer.next(false);
      }
      observer.complete();
    });
  }
  
  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}api/login`, credentials);
  }
  getStreamSong(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/streamSong`, { headers });
  }
  getDownloadSong(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/downloadSong`, { headers });
  }
  getTopArtist(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/getTopArtist`, { headers });
  }
  getTopAlbum(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/gettopAlbums`, { headers });
  }
  getmpodTopsongs(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/MPOD/top10-songs`, { headers });
  }
  getmpodTopArtist(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/MPOD/top10-artists`, { headers });
  }
  getBuddieBeatzChart(): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/chart`, { headers });
  }
  getCrbtChart(): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });
    return this.http.get<any>(`${this.apiUrl}api/crbt/chart`, { headers });
  }
  getMpodChart(): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });
    return this.http.get<any>(`${this.apiUrl}api/MPOD/chart`, { headers });
  }
  getCp(): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
    });
    return this.http.get<any>(`${this.apiUrl}api/buddie_beatz/CP`, { headers });
  }
  getcrbtTopcrbt(): Observable<any> {
    const token = sessionStorage.getItem('token'); 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`, 
    });
    return this.http.get<any>(`${this.apiUrl}api/crbt/top10-crbt`, { headers });
  }
  fetchReportData(requestBody: any): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
   
    return this.http.post<any>(`${this.apiUrl}api/buddie_beatz/report`, requestBody, { headers });
  }
  getUserById(id: number): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get<any>(`${this.apiUrl}api/user/${id}`, { headers });
  }
  changePassword(requestBody: { userId: string, oldPassword: string, newPassword: string }): Observable<any> {
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(`${this.apiUrl}api/change-password`, requestBody, { headers });
  }
  
  clearAuthToken(): void {
    sessionStorage.removeItem('token');
  }
  
  CheckData(requestBody:any):Observable<any>{
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.post(`${this.apiUrl}api/buddie_beatz/record`, requestBody , {headers} )
  }
  
  getYearAndMonth():Observable<any>{
    const token = sessionStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    return this.http.get(`${this.apiUrl}api/buddie_beatz/report`, { headers } )
  }

}


